/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from "class-transformer";
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity, OneToMany } from "typeorm";
import { AdditiveProductInformation } from "./additiveProductInformation.entity";
import { AllergensProductInformation } from "./allergensProductInformation.entity";
import { ProductImage } from "./productImage.entity";

@Entity()
export class ProductInformation extends SmBaseEntity {
    @Column({default: 0})
    id: number = 0;

    @Column({default: ""})
    wfId: string = "";

    @Column({default: ""})
    supplierMail: string = "";

    //Wurde vom Benutzer im Portal abgeschickt und wartet auf Abholung durch DocumentHandler
    @Column({default: false})
    requestFinished: boolean = false;

    //Die bereitgestellten Daten wurden vom DocumentHandler abgeholt und wieder an den Workflow übergeben
    @Column({default: false})
    requestProcessed: boolean = false;

    //Es handelt sich um eine Folgebearbeitung, nachdem im Workflow Anpassungsbedarf erkannt wurde
    @Column({default: false})
    requestPostProcessing: boolean = false;

    @Column({default: ""})
    productCategory: string = "";

    @Column({default: ""})
    hintsfromEnaio: string = "";

    // Tab Grundinformationen
    @Column({default: ""})
    basicRNumber: string = "";

    @Column({default: ""})
    basicProductName: string = "";

    @Column({default: 0})
    basicFatContent: number = 0;

    @Column({default: ""})
    basicIsBio: string = "";

    @Column({default: ""})
    basicBioNumber: string = "";

    @Column({default: false})
    eudr: boolean = false;

    @Column({default: ""})
    eudrItems: string = "";

    @Column({default: ""})
    basicRungisSupplierNumber: string = "";

    @Column({default: ""})
    basicSupplierName: string = "";

    @Column({default: ""})
    basicDealerManufacturer: string = "";

    @Column({default: ""})
    basicManufacturerAddress: string = "";

    //Tab Artikeldetails
    @Column({default: ""})
    detailsSupplierProductName: string = "";

    @Column({default: ""})
    detailsProductDescription: string = "";

    @Column({default: ""})
    detailsSupplierProductNumber: string = "";

    @Column({default: false})
    detailsSupplierProductNumberNotAvailable: boolean = false;

    @Column({default: ""})
    detailsBrand: string = "";

    @Column({default: false})
    detailsBrandNotAvailable: boolean = false;

    @Column({default: null})
    @Type(() => Date)
    detailsDateOfSpecification: Date = null;

    @Column({default: false})
    detailsSpecificationChecked: boolean = false;

    @Column({default: ""})
    detailsGermanLabel: string = "";

    @Column({default: ""})
    detailsGermanLabelFile: string = "";

    @Column({default: ""})
    detailsOriginalSpecificationFile: string = "";

    @Column({default: ""})
    detailsProductImage: string = "";

    @OneToMany((_type) => ProductImage, o => o.product, {cascade: true})
    @Type(() => ProductImage)
    detailsProductImagesFiles: ProductImage[];

    @Column({default: false})
    detailsProductImageRights: boolean = false;

    @Column({default: ""})
    detailsUnit: string = "";

    @Column({default: ""})
    detailsPricePerUnit: string = "";

    @Column({default: false})
    bestBeforeNotRequired: boolean = false;

    @Column({default: 0})
    detailsBestBeforeDays: number = 0;

    @Column({default: 0})
    detailsGuaranteedBestBefore: number = 0;

    @Column({default: 0})
    detailsDaysUntilDelivery: number = 0;

    @Column({default: 0})
    detailsMinOrderQuantity: number = 0;

    @Column({default: ""})
    detailsCustomsFeeNumber: string = "";

    @Column({default: false})
    customsApiOffline: boolean = false;

    ///Tab Allgemeine Herkunft
    @Column({default: ""})
    herkunftslandAlg: string = "";

    @Column({default: ""})
    zusaetzlicheArtikelInfos: string = "";

    @Column({default: ""})
    sensorik: string = "";

    @Column({default: ""})
    verwendungszweck: string = "";

    @Column({default: ""})
    schaerfegrad: string = "";

    @Column({default: ""})
    schaerfegradIcon: string = "";

    @Column({default: ""})
    klasse: string = "";

    @Column({default: ""})
    kaliber: string = "";

    @Column({default: ""})
    raeucherart: string = "";

    @Column({default: ""})
    holzart: string = "";

    @Column({default: ""})
    salzgehalt: string = "";

    @Column({default: ""})
    korngroesseDesKaviars: string = "";

    @Column({default: ""})
    verarbeitungstemperatur: string = "";

    @Column({default: ""})
    wasserFettloeslich: string = "";

    //Tab Herkunft Fleisch
    @Column({default: ""})
    beefBornIn: string = "";

    @Column({default: ""})
    beefGrownIn: string = "";

    @Column({default: ""})
    beefButcheredIn: string = "";

    @Column({default: ""})
    beefCutIn: string = "";

    @Column({default: ""})
    meatGrownIn: string = "";

    @Column({default: ""})
    meatButcheredIn: string = "";

    @Column({default: ""})
    fleischFuetterung: string = "";

    @Column({default: ""})
    fleischGeschlecht: string = "";

    @Column({default: ""})
    fleischMuttertierhaltung: string = "";

    @Column({default: ""})
    fleischMitKetten: string = "";

    @Column({default: ""})
    fleischMitKnochen: string = "";

    @Column({default: ""})
    fleischPattieDurchmesser: string = "";

    @Column({default: ""})
    fleischRasseZucht: string = "";

    @Column({default: ""})
    fleischSchlachtalter: string = "";

    @Column({default: ""})
    fleischWolfgrad: string = "";

    @Column({default: ""})
    fleischZuchtRasse: string = "";

    @Column({default: ""})
    haltungsform: string = "";

    //Tab Herkunft Fisch
    @Column({default: ""})
    fishIsASC: string = "";

    @Column({default: ""})
    fishIsMSC: string = "";

    @Column({default: ""})
    fishAscMscNumber: string = "";

    @Column({default: ""})
    fishWater: string = "";

    @Column({default: false})
    fishAquaculture: boolean = false;

    @Column({default: ""})
    fishOriginAC: string = "";

    @Column({default: ""})
    fishCatchmentArea: string = "";

    @Column({default: ""})
    fishSubCatchmentArea: string = "";

    @Column({default: false})
    fishInlandFisheries: boolean = false;

    @Column({default: ""})
    fishWildGearCategory: string = "";

    @Column({default: false})
    fishWildCaught: boolean = false;

    @Column({default: ""})
    fishInlandOrigin: string = "";

    @Column({default: ""})
    fishInlandGearCategory: string = "";

    @Column({default: ""})
    fischAusgenommen: string = "";

    @Column({default: ""})
    fischMitHaut: string = "";

    @Column({default: ""})
    fischMitKopf: string = "";

    @Column({default: false})
    fischGeschuppt: boolean = false;

    //Tab Feinkost / Backwaren
    @Column({default: ""})
    feinkostEinheitGroesse: string = "";

    @Column({default: ""})
    feinkostFiltration: string = "";

    @Column({default: ""})
    feinkostGepresst: string = "";

    @Column({default: ""})
    feinkostGeschmack: string = "";

    @Column({default: ""})
    feinkostGroesse: string = "";

    @Column({default: ""})
    feinkostKaeseArt: string = "";

    @Column({default: ""})
    feinkostMehlsorten: string = "";

    @Column({default: ""})
    feinkostRebsorte: string = "";

    @Column({default: ""})
    feinkostReifegrad: string = "";

    @Column({default: ""})
    feinkostReifegradEinheit: string = "";

    @Column({default: ""})
    feinkostReifung: string = "";

    @Column({default: ""})
    feinkostReifungEinheit: string = "";

    @Column({default: ""})
    feinkostSauerteig: string = "";

    @Column({default: ""})
    feinkostSortimentinhalt: string = "";

    @Column({default: ""})
    feinkostSaeuregehalt: string = "";

    //Tab Logistik und Verpackung
    @Column({default: ""})
    logisticsEANPiece: string = "";

    @Column({default: false})
    logisticsEANPieceNotAvailable: boolean = false;

    @Column({default: ""})
    logistikEinheitFuellmenge: string = "";

    @Column({default: ""})
    logisticsEANBox: string = "";

    @Column({default: false})
    logisticsEANBoxNotAvailable: boolean = false;

    @Column({default: ""})
    einheitNettofuellmengeVerkaufseinheit: string = "";

    @Column({default: ""})
    logisticsNetWeightPiece: string = "";

    @Column({default: false})
    logisticsNetWeightPieceNotAvailable: boolean = false;

    @Column({default: ""})
    logisticsNetWeightBox: string = "";

    @Column({default: false})
    logisticsNetWeightBoxNotAvailable: boolean = false;

    @Column({default: ""})
    logisticsGrossWeightPiece: string = "";

    @Column({default: false})
    logisticsGrossWeightPieceNotAvailable: boolean = false;

    @Column({default: ""})
    logisticsGrossWeightBox: string = "";

    @Column({default: false})
    logisticsGrossWeightBoxNotAvailable: boolean = false;

    @Column({default: ""})
    logisticsDimensionsPieceL: string = "";

    @Column({default: ""})
    logisticsDimensionsPieceB: string = "";

    @Column({default: ""})
    logisticsDimensionsPieceH: string = "";

    @Column({default: false})
    logisticsDimensionsPieceNotAvailable: boolean = false;

    @Column({default: ""})
    logisticsDimensionsBoxL: string = "";

    @Column({default: ""})
    logisticsDimensionsBoxB: string = "";

    @Column({default: ""})
    logisticsDimensionsBoxH: string = "";

    @Column({default: false})
    logisticsDimensionsBoxNotAvailable: boolean = false;

    @Column({default: ""})
    packagingGlassWeight: string = "";

    @Column({default: false})
    packagingGlassWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingPaperWeight: string = "";

    @Column({default: false})
    packagingPaperWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingTinplateWeight: string = "";

    @Column({default: false})
    packagingTinplateWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingAluminumWeight: string = "";

    @Column({default: false})
    packagingAluminumWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingPlasticWeight: string = "";

    @Column({default: false})
    packagingPlasticWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingCompositeWeight: string = "";

    @Column({default: false})
    packagingCompositeWeightNotAvailable: boolean = false;

    @Column({default: ""})
    packagingNaturalWeight: string = "";

    @Column({default: false})
    packagingNaturalWeightNotAvailable: boolean = false;

    @Column({default: 0})
    packagingPiecesPerBox: number = 0;

    @Column({default: 0})
    packagingBoxesPerLayer: number = 0;

    @Column({default: 0})
    packagingLayersPerPalette: number = 0;

    @Column({default: 0})
    packagingTotalPerPalette: number = 0;

    //Tab Allergene
    @Column({default: false})
    allergenesNotAvailable: boolean = false;

    @OneToMany((_type) => AllergensProductInformation, o => o.product, {cascade: true})
    @Type(() => AllergensProductInformation)
    allergens: AllergensProductInformation[];

    //Tab Nährwertangaben
    @Column({default: ""})
    nutritionIngredients: string = "";

    @Column({default: ""})
    nutritionNA: string = "";

    @Column({default: ""})
    nutritionKjKcal: string = "";

    @Column({default: false})
    nutritionKjKcalNA: boolean = false;

    @Column({default: ""})
    nutritionFat: string = "";

    @Column({default: false})
    nutritionFatNA: boolean = false;

    @Column({default: ""})
    nutritionsaturatedFat: string = "";

    @Column({default: false})
    nutritionSaturatedFatNA: boolean = false;

    @Column({default: ""})
    nutritionCarbs: string = "";

    @Column({default: false})
    nutritionCarbsNA: boolean = false;

    @Column({default: ""})
    nutritionCarbsSugar: string = "";

    @Column({default: false})
    nutritionCarbSugarNA: boolean = false;

    @Column({default: ""})
    nutritionProtein: string = "";

    @Column({default: false})
    nutritionProteinNA: boolean = false;

    @Column({default: ""})
    nutritionSalt: string = "";

    @Column({default: false})
    nutritionSaltNA: boolean = false;

    //Tab Zusatzstoffe
    @Column({default: ""})
    additivesLMIV: string = "";

    @OneToMany((_type) => AdditiveProductInformation, o => o.product, {cascade: true})
    @Type(() => AdditiveProductInformation)
    additives: AdditiveProductInformation[];

    //Tab Hinweise
    @Column({default: false})
    hintsRecommendationNotAvailable: boolean = false;

    @Column({default: ""})
    hintsRecommendation: string = "";

    @Column({default: ""})
    hintsRequiresRefrigeration: string = "";

    @Column({default: ""})
    hintsRefrigerationTemperature: string = "";

    @Column({default: ""})
    hintsStorageInstructions: string = "";

    @Column({default: ""})
    hintsSpecialMarkings: string = "";

    @Column({default: false})
    hintsMarkingGluten: boolean = false;

    @Column({default: false})
    hintsMarkingVegetarian: boolean = false;

    @Column({default: false})
    hintsMarkingVegan: boolean = false;

    @Column({default: false})
    hintsMarkingLaktoseFree: boolean = false;

    @Column({default: false})
    hintsMarkingAlcohol: boolean = false;

    @Column({default: 0})
    hintsMarkingAlcoholAmount: number = 0;

    @Column({default: ""})
    hintsGeneticallyModified: string = "";

    @Column({default: ""})
    hintsObtainedGeneticallyModifiedOrganisms: string = "";

    @Column({default: ""})
    hintsProducedGeneticallyModifiedOrganisms: string = "";

    @Column({default: ""})
    hintsIonizingRadiation: string = "";

    @Column({default: ""})
    hintsIonizingRadiationIngredients: string = "";

    @Column({default: false})
    hintsConfirmed: boolean = false;

    @Column({default: ""})
    hinweisAuftautemperatur: string = "";

    @Column({default: ""})
    hinweisAuftauzeit: string = "";

    @Column({default: ""})
    hinweisBacktemperatur: string = "";

    @Column({default: ""})
    hinweisBackzeit: string = "";

    @Column({default: ""})
    hinweisFrittierTemperatur: string = "";

    @Column({default: ""})
    hinweisFrittierZeit: string = "";

    //Tab Bestätigung
    @Column({default: null})
    @Type(() => Date)
    confirmationDate: Date = null;

    @Column({default: ""})
    confirmationName: string = "";

    @Column({default: false})
    confirmation: boolean = false;

    @Column({default: true})
    uploadRequired: boolean = true;

    @Column({default: ""})
    customsNumberDescription: string = "";
}